<template>
  <div>
    <v-card class="rounded-lg elevation-3 overflow-hidden">
      <!-- Toolbar Header -->
      <v-toolbar height="58" color="secondary" dark flat class="px-3">
        <div class="d-flex align-center">
          <v-icon left>mdi-alert-octagon-outline</v-icon>
          <span class="text-h6 font-weight-medium">
            {{ Titulo || "Neumáticos en mal estado" }}
          </span>
          <v-chip
            small
            color="white"
            text-color="secondary"
            class="font-weight-bold ml-3 px-3 elevation-1"
            style="font-size: 0.95rem; height: 32px"
          >
            <v-icon left size="18" color="secondary">mdi-counter</v-icon>
            {{ ItemTotal || (Items ? Items.length : 0) }}
          </v-chip>
        </div>

        <v-spacer></v-spacer>

        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mx-1 btn-circle-tooltip"
              icon
              dark
              v-bind="attrs"
              v-on="on"
            >
              <v-icon size="25" color="amber lighten-2">mdi-alert-circle-outline</v-icon>
            </v-btn>
          </template>
          <span>Listado de neumáticos en mal estado</span>
        </v-tooltip>
      </v-toolbar>

      <div class="pa-4 pb-2">
        <!-- Barra de leyenda de iconos / opciones con estilo v-alert -->
        <v-alert
          colored-border
          border="top"
          color="orange darken-3"
          elevation="1"
          icon="mdi-information-outline"
          class="orange lighten-5 rounded-lg mb-4 pa-3 pa-sm-4 alert-icon-leyenda w-100"
        >
          <div class="leyenda-container">
            <p class="leyenda-desc mb-3">
              Los neumáticos que se listan aquí se encuentran en
              <strong>mal estado</strong> y están listos para ser
              <strong>reemplazados</strong> o gestionados para su reparación,
              reencauche o scrap.
            </p>

            <div class="leyenda-grid">
              <!-- 1. Editar -->
              <div class="leyenda-item">
                <v-btn
                  height="18"
                  width="18"
                  color="blue lighten-2"
                  fab
                  x-small
                  dark
                  class="mr-1 levation-1"
                >
                  <v-icon x-small>mdi-pencil</v-icon>
                </v-btn>
                <div class="leyenda-text">
                  <strong class="blue--text text--darken-4 mr-1"
                    >Editar:</strong
                  >
                  <span
                    >Modificar remanente final, fecha o motivo de retiro.</span
                  >
                </div>
              </div>

              <!-- 2. Reparar -->
              <div class="leyenda-item">
                <v-btn
                  height="18"
                  width="18"
                  color="green"
                  fab
                  x-small
                  dark
                  class="mr-1 levation-1"
                >
                  <v-icon x-small>mdi-brightness-5</v-icon>
                </v-btn>
                <div class="leyenda-text">
                  <strong class="green--text text--darken-4 mr-1"
                    >Reparar:</strong
                  >
                  <span
                    >Enviar neumático al taller / proceso de reparación.</span
                  >
                </div>
              </div>

              <!-- 3. Reencauchar -->
              <div class="leyenda-item">
                <v-btn
                  height="18"
                  width="18"
                  color="#8E938E"
                  fab
                  x-small
                  dark
                  class="mr-1 levation-1"
                >
                  <v-icon x-small>mdi-brightness-5</v-icon>
                </v-btn>
                <div class="leyenda-text">
                  <strong class="grey--text text--darken-4 mr-1"
                    >Reencauchar:</strong
                  >
                  <span>Enviar neumático al proceso de reencauche.</span>
                </div>
              </div>

              <!-- 4. Scrap -->
              <div class="leyenda-item">
                <v-btn
                  height="18"
                  width="18"
                  color="red"
                  fab
                  x-small
                  dark
                  class="mr-1 levation-1"
                >
                  <v-icon x-small>mdi-download</v-icon>
                </v-btn>
                <div class="leyenda-text">
                  <strong class="red--text text--darken-4 mr-1">Scrap:</strong>
                  <span>Dar de baja definitiva y enviar a Scrap.</span>
                </div>
              </div>

              <!-- 5. Redireccionar -->
              <div class="leyenda-item">
                <v-btn
                  height="18"
                  width="18"
                  color="orange"
                  fab
                  x-small
                  dark
                  class="mr-1 levation-1"
                >
                  <v-icon x-small>mdi-arrow-right-bottom-bold</v-icon>
                </v-btn>
                <div class="leyenda-text">
                  <strong class="orange--text text--darken-4 mr-1"
                    >Redireccionar:</strong
                  >
                  <span
                    >Ir a la vista del vehículo (cuando está instalado).</span
                  >
                </div>
              </div>
            </div>
          </div>
        </v-alert>

        <!-- Barra de Control: Búsqueda y Botones -->
        <div
          class="d-flex align-center justify-space-between flex-wrap gap-2 mb-3"
        >
          <div class="search-field flex-grow-1 mr-md-3">
            <v-text-field
              v-model="search"
              outlined
              dense
              single-line
              hide-details
              prepend-inner-icon="mdi-magnify"
              clearable
              placeholder="Buscar por serie, marca, modelo, vehículo..."
              class="rounded-lg"
            ></v-text-field>
          </div>

          <div class="d-flex align-center flex-wrap gap-2 mt-2 mt-md-0">
            <v-btn
              v-if="Excel"
              color="success"
              dark
              height="38"
              class="px-4 font-weight-bold elevation-1 text-none rounded-lg"
              @click="DescargarExcel()"
            >
              <v-icon left size="20">mdi-file-excel-box</v-icon>
              Descargar Tabla
            </v-btn>

            <v-btn
              color="primary"
              dark
              height="38"
              class="px-4 font-weight-bold elevation-1 text-none rounded-lg"
              v-if="Crear"
              @click="nuevoItem()"
            >
              <v-icon left size="20">mdi-plus-circle</v-icon>
              Nuevo
            </v-btn>

            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  height="38"
                  class="px-4 font-weight-bold elevation-1 text-none rounded-lg"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon left size="20">mdi-download</v-icon>
                  Exportar
                  <v-icon right small>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list dense class="rounded-lg">
                <v-list-item
                  v-for="(item, index) in opcionesAexportar"
                  :key="index"
                  @click="exportarAExcel(item.text)"
                >
                  <v-list-item-icon class="mr-2">
                    <v-icon small color="primary">mdi-file-excel</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>
      </div>

      <!-- Tabla Responsiva -->
      <div class="table-responsive-wrapper">
        <v-data-table
          dense
          :headers="Cabecera"
          :items="Items"
          :items-per-page="10"
          :search="search"
          :loading="loading"
          loading-text="Cargando neumáticos en mal estado... Por favor, espere"
          class="elevation-0 modern-table"
          no-data-text="No hay datos disponibles"
          :footer-props="{
            'items-per-page-text': 'Resultados por página:',
            'page-text': '{0}-{1} de {2}',
          }"
        >
          <template v-slot:[`item.acciones`]="{ item }">
            <div class="d-flex align-center gap-1">
              <template v-if="item.estado_descripcion == 'desinstalado'">
                <v-tooltip
                  bottom
                  v-if="
                    global._autorizacion_usuario(Permisos, $route.meta.id, ['3'])
                  "
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      height="24"
                      width="24"
                      color="blue lighten-2"
                      fab
                      x-small
                      dark
                      class="action-btn elevation-1"
                      @click="editarItem(item)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon x-small>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      height="24"
                      width="24"
                      color="green"
                      fab
                      x-small
                      dark
                      class="action-btn elevation-1"
                      @click="modalRepararNeumatico(item)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon x-small>mdi-brightness-5</v-icon>
                    </v-btn>
                  </template>
                  <span>Reparar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      height="24"
                      width="24"
                      color="#8E938E"
                      fab
                      x-small
                      dark
                      class="action-btn elevation-1"
                      @click="modalReencaucharNeumatico(item)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon x-small>mdi-brightness-5</v-icon>
                    </v-btn>
                  </template>
                  <span>Reencauchar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      height="24"
                      width="24"
                      color="red"
                      fab
                      x-small
                      dark
                      class="action-btn elevation-1"
                      @click="modalScrapNeumatico(item)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon x-small>mdi-download</v-icon>
                    </v-btn>
                  </template>
                  <span>Scrap</span>
                </v-tooltip>
              </template>
              <template v-else>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      height="24"
                      width="24"
                      color="orange"
                      fab
                      x-small
                      dark
                      class="action-btn elevation-1"
                      @click="gomantvehi(item.id_vehiculo)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon x-small>mdi-arrow-right-bottom-bold</v-icon>
                    </v-btn>
                  </template>
                  <span>Redireccionar al vehículo</span>
                </v-tooltip>
              </template>
            </div>
          </template>

          <!-- N° Serie destacado -->
          <template v-slot:[`item.num_serie`]="{ item }">
            <span class="font-weight-bold font-mono text--primary">
              {{ item.num_serie }}
            </span>
          </template>

          <template v-slot:[`item.image`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="info"
                  height="26"
                  depressed
                  class="px-3 font-weight-medium text-caption text-none rounded-pill elevation-1"
                  dark
                  @click="verImagen(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon left x-small>mdi-image-multiple-outline</v-icon>
                  Ver imagen
                </v-btn>
              </template>
              <span>Ver fotos del neumático</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </div>
    </v-card>

    <Imagen
      ref="Imagen"
      :dialog="dialog_image"
      @dialog="dialog_image = $event"
      :Item="itemSelected"
    />

    <Editar
      ref="scrap"
      Titulo="Editar Neumático en mal estado"
      :dialog="dialog_edit"
      @dialog="dialog_edit = $event"
      :Item="itemSelected"
      :MotivosScrap="MotivosScrap"
    />

    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-toolbar color="grey" dark height="40">
          {{ title }}
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row justify="center">
              <v-col cols="12" sm="12" md="12">
                <h3 class="text-center">{{ mensaje }}</h3>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="dialog = false"> Cancelar </v-btn>
          <v-btn color="info" @click="guardar()"> {{ nameButton }} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_warning" persistent max-width="500px">
      <v-card>
        <v-toolbar color="grey" dark height="40"> AVISO </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row justify="center">
              <v-col cols="12" sm="12" md="12">
                <h3 class="text-center">
                  ¡Por favor, ingrese su remanente final para continuar!
                </h3>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="dialog_warning = false">
            Cancelar
          </v-btn>
          <v-btn color="info" @click="enviarDialog()"> Llenar remanente </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
// import axios from "axios";
import { axios2 as axios } from "@/interceptor/useApi";
import Editar from "../scrap/editar.vue";
import Imagen from "../scrap/imagen.vue";
import global from "../../global";
import { mapState } from "vuex";

export default {
  props: [
    "Titulo",
    "Cabecera",
    "loading",
    "Items",
    "Item",
    "ItemTotal",
    "Excel",
    "Crear",
  ],
  components: {
    Imagen,
    Editar,
  },
  data() {
    return {
      dialog: false,
      title: "",
      mensaje: "",
      search: "",
      nameButton: "",
      dialog_edit: false,
      dialog_image: false,
      MotivosScrap: [],
      itemSelected: {},
      dialog_warning: false,
      opcionesAexportar: [
        {
          id: 1,
          text: "Exportar Excel",
        },
        {
          id: 2,
          text: "Exportar CSV",
        },
      ],
      /* extension: "", */
      ruta: "",
      global: global,
    };
  },
  computed: {
    ...mapState("navigation", ["Permisos"]),
  },
  methods: {
    ...mapState("enmalestado", ["cargarNeumaticos"]),

    verImagen(item) {
      this.itemSelected = item;
      this.dialog_image = true;
    },

    exportarAexcel: function () {
      axios
        .get(
          "excel/reporteneumaticosenmalestado?" +
            global._json_to_query_string({
              id_cliente: localStorage.getItem("idcliente"),
              extension: text,
            }),
          {
            responseType: "blob", // Importante: especificar que la respuesta es un blob
          },
        )
        .then((response) => {
          console.log("response", response);
          // Procesar y descargar el archivo después de que la promesa se resuelva
          const contentType = response.headers["content-type"];
          let fileName = response.headers["nombre-archivo"] || "archivo.xlsx";

          if (
            contentType ===
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          ) {
            const fileBlob = new Blob([response.data], { type: contentType });
            const downloadLink = document.createElement("a");
            downloadLink.href = URL.createObjectURL(fileBlob);
            downloadLink.download = fileName;
            document.body.appendChild(downloadLink); // Agregar al DOM
            downloadLink.click();
            document.body.removeChild(downloadLink); // Limpiar el DOM
            URL.revokeObjectURL(downloadLink.href); // Liberar memoria
          } else {
            throw new Error("La respuesta no es un archivo Excel");
          }
        })
        .catch((error) => {
          this.errorMessage = error.response?.data || error.message;
          console.error("error!", error);
        });
    },

    editarItem(item) {
      item.remanente_final =
        item.remanente_final == "-" ? null : item.remanente_final;
      item.fecha = item.fecha_scrap;
      this.itemSelected = item;
      this.dialog_edit = true;
    },

    modalRepararNeumatico(item) {
      this.dialog = true;
      this.itemSelected = item;
      this.ruta = "neumaticos/enviarAreparar";
      this.title = "Reparar neumático en mal estado: " + item.num_serie;
      this.mensaje = "¿Esta seguro que desea reparar este neumatico?";
      this.nameButton = "Reparar";
    },

    modalReencaucharNeumatico(item) {
      this.dialog = true;
      this.itemSelected = item;
      this.ruta = "neumaticos/enviarAreencauchar";
      this.title = "Reencauchar neumático en mal estado: " + item.num_serie;
      this.mensaje = "¿Esta seguro que desea reencauchar este neumatico?";
      this.nameButton = "Reencauchar";
    },
    gomantvehi(id_vehiculo) {
      this.$router.push({ path: `/ubicaciontemporal` });
      setTimeout(() => {
        this.$router.push({ path: `/vehiculo/instalacion/${id_vehiculo}` });
      }, 10); // Usa un retraso mínimo, como 10ms
    },

    modalScrapNeumatico(item) {
      this.dialog = true;
      this.itemSelected = item;
      this.ruta = "neumaticos/enviarAscrap";
      this.title = "Scrap neumático en mal estado: " + item.num_serie;
      this.mensaje = "¿Esta seguro que desea enviar este neumatico a SCRAP?";
      this.nameButton = "Enviar a SCRAP";
    },

    async guardar() {
      if (
        this.itemSelected.remanente_final == "-" ||
        this.itemSelected.remanente_final === null
      ) {
        this.dialog_warning = true;
        this.dialog = false;
      } else {
        try {
          const url = this.ruta;
          const data = {
            id_cliente: localStorage.getItem("idcliente"),
            id_usuario: localStorage.getItem("id"),
            id_neumatico: this.itemSelected.id,
          };
          await axios
            .post(url, data)
            .then((response) => {
              this.dialog = false;
              this.$emit("actualizartabla");
              this.$alertify.success("Operación realizada satisfactoriamente");
            })
            .catch((error) => {
              this.errorMessage = error.response.data;
              console.error("error!", error);
            });
        } catch (error) {
          console.log(error);
        }
      }
    },

    enviarDialog() {
      this.dialog_warning = false;
      this.editarItem(this.itemSelected);
    },
  },
};
</script>

<style scoped>
.w-100 {
  width: 100% !important;
}

.alert-icon-leyenda {
  width: 100% !important;
  box-sizing: border-box;
}

.alert-icon-leyenda ::v-deep .v-alert__wrapper {
  align-items: flex-start !important;
}

.alert-icon-leyenda ::v-deep .v-alert__icon {
  margin-top: 2px !important;
}

.leyenda-container {
  width: 100%;
}

.leyenda-desc {
  font-size: 14px;
  line-height: 1.45;
  color: #1e293b;
}

.leyenda-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 8px 12px;
  width: 100%;
}

.leyenda-item {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.7);
  padding: 6px 5px;
  border-radius: 8px;
  border: 1px solid rgba(245, 158, 11, 0.25);
  transition: all 0.2s ease;
}

.leyenda-item:hover {
  background: rgba(255, 255, 255, 0.95);
  border-color: rgba(245, 158, 11, 0.5);
  transform: translateY(-1px);
}

.leyenda-text {
  font-size: 10px;
  line-height: 1.35;
  color: #334155;
}

@media (max-width: 768px) {
  .leyenda-grid {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .leyenda-desc {
    font-size: 13px;
  }

  .leyenda-text {
    font-size: 12.5px;
  }
}

.modern-table {
  border-top: 1px solid #e2e8f0;
}

.modern-table ::v-deep thead tr:not(.v-data-table__progress) th {
  background-color: #424242 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  font-size: 0.8rem !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  white-space: nowrap;
  border-bottom: 2px solid #212121 !important;
  border-right: 1px solid rgba(255, 255, 255, 0.12) !important;
  padding: 10px 14px !important;
  height: 42px !important;
}

.modern-table ::v-deep thead tr:not(.v-data-table__progress) th .v-data-table-header__icon {
  color: #ffffff !important;
}

.modern-table ::v-deep .v-data-table__progress th {
  background: transparent !important;
  background-color: transparent !important;
  border: none !important;
  padding: 0 !important;
  height: auto !important;
}

.modern-table ::v-deep .v-data-table__empty-wrapper td {
  background: transparent !important;
  background-color: transparent !important;
}

.modern-table ::v-deep td {
  font-size: 0.85rem !important;
  padding: 8px 14px !important;
  border-bottom: 1px solid #f1f5f9 !important;
  vertical-align: middle;
}

.modern-table ::v-deep tbody tr:hover {
  background-color: #f8fafc !important;
  transition: background-color 0.15s ease-in-out;
}

.modern-table ::v-deep .v-data-footer {
  border-top: 1px solid #e2e8f0;
  background-color: #f8fafc;
  font-size: 0.82rem;
  padding: 8px 16px;
}

.table-responsive-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-responsive-wrapper::-webkit-scrollbar {
  height: 6px;
}

.table-responsive-wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.search-field {
  max-width: 360px;
  min-width: 220px;
}

@media (max-width: 768px) {
  .search-field {
    max-width: 100%;
    width: 100%;
  }
}

.action-btn {
  transition: transform 0.18s ease-in-out, box-shadow 0.18s ease-in-out;
}

.action-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2) !important;
}

.font-mono {
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier,
    monospace;
}

.gap-1 {
  gap: 4px;
}

.gap-2 {
  gap: 8px;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip ::v-deep .v-btn__content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  line-height: 1 !important;
}

.btn-circle-tooltip ::v-deep .v-icon {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
}
</style>
